module.exports = __webpack_public_path__ + "img/empty.86543eee.png";